import { useEffect } from "react";

const BASE_TITLE = "Casvi Software";

export const useDocumentTitle = (title) => {
  useEffect(() => {
    document.title = title ? `${title} · ${BASE_TITLE}` : `${BASE_TITLE} · Convertimos ideas en software`;
  }, [title]);
};
